'use client';

import { generateId } from 'ai';

import type { StructuredMessage } from '@/lib/whatsapp/types';

const serverMessageIdByThread = new Map<string, string>();
const remoteIdByLocalId = new Map<string, string>();

export function generateMessageId(): string {
  return generateId();
}

export function setServerMessageId(threadId: string, messageId: string): void {
  serverMessageIdByThread.set(threadId, messageId);
}

export function popServerMessageId(threadId: string): string | null {
  const serverId = serverMessageIdByThread.get(threadId);
  if (serverId) {
    serverMessageIdByThread.delete(threadId);
    return serverId;
  }
  return null;
}

export function setRemoteIdForMessage(localId: string, remoteId: string): void {
  remoteIdByLocalId.set(localId, remoteId);
}

export function getRemoteIdForMessage(localId: string): string | null {
  return remoteIdByLocalId.get(localId) ?? null;
}

export function resolveStructuredText(text: string): string {
  try {
    const parsed = JSON.parse(text);
    if (!parsed?.messages || !Array.isArray(parsed.messages)) return text;

    return (parsed.messages as StructuredMessage[])
      .map(({ text, link }) => {
        if (link?.url && link?.buttonText) {
          return `${text}\n[${link.buttonText}](${link.url})`;
        }
        return text;
      })
      .join('\n\n');
  } catch {
    return text;
  }
}
